import {Badge} from "@mantine/core";
import {BindingDriftReport, DriftAction} from "../types.ts";
import {runNeedsAttention} from "../utils/runHealth.ts";

// Health badge for a sweep run. Green when clean; red when repairs failed or the cap
// was hit; gray when there was simply no drift to act on.
export const RunHealthBadge = ({record}: { record: BindingDriftReport }) => {
    if (runNeedsAttention(record)) {
        const reason = (record.repairFailedCount ?? 0) > 0 ? 'Repair failed' : 'Repair capped';
        return <Badge color={'red'}>{reason}</Badge>;
    }
    if ((record.driftDetectedCount ?? 0) > 0) {
        return <Badge color={'green'}>Drift repaired</Badge>;
    }
    return <Badge color={'gray'}>No drift</Badge>;
};

// Per-account finding action badge.
export const ActionBadge = ({action}: { action: DriftAction | string }) => {
    let color = 'gray';
    if (action === 'REPAIRED') {
        color = 'green';
    } else if (action === 'REPAIR_FAILED') {
        color = 'red';
    } else if (action === 'CAP_EXCEEDED') {
        color = 'orange';
    } else if (action === 'SKIPPED_TOCTOU' || action === 'SKIPPED_STATUS') {
        color = 'yellow';
    }
    return <Badge color={color}>{action}</Badge>;
};
